import styled from 'styled-components'
import { Row } from 'antd'

export const Wrapper = styled(Row)`
  width: calc(100% - 400px);
  min-width: 200px;
`
